import React from 'react'
import { ItemProps } from './type'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'

/**
 * https://docs.dndkit.com/presets/sortable#sortable
 * https://docs.dndkit.com/introduction/getting-started
 * https://docs.dndkit.com/presets/sortable#multiple-containers
 * @param props 
 * @returns 
 */
export const Sortable = <T extends React.ElementType>(props: ItemProps<T>) => {
    const {
        as,
        id,
        data,
        style,
        children,
        withinScrollFix,
        ...rest
    } = props
    const Element = as

    const {
        isDragging,
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({
        id: props.id,
        data: props.data,
    })

    const scrollFixStyle: React.CSSProperties | undefined = transform
        ? {
              // FIXME https://docs.dndkit.com/api-documentation/draggable/drag-overlay
              // If your draggable item is within a scrollable container, we also recommend you use a <DragOverlay>, otherwise you'll need to set the draggable element to position: fixed yourself so the item isn't restricted to the overflow and stacking context of its scroll container, and can move without being affected by the scroll position of its container.
              position: withinScrollFix ? 'fixed' : 'relative',
              opacity: isDragging ? 0.4 : 1,
              transform: CSS.Transform.toString(transform),
              transition,
          }
        : undefined

    return (
        <Element
            ref={setNodeRef}
            style={{
                ...style,
                ...scrollFixStyle,
            }}
            {...listeners}
            {...attributes}
            {...rest}
        >
            {children}
        </Element>
    )
}
